import * as React from 'react';
import b_ from 'b_';
import { NavLink } from 'shared/components/NavLink';
import { useTranslation } from 'react-i18next';
import {
  // @translate(context:ideaFilter)
  IdeaFilterOption,
} from '../../consts/ideaOptions';
import { useTabs } from './hooks';

import './index.scss';

export interface Props {
  root: string;
}

const b = b_.with('idea-filters');

export const IdeaFilters: React.FC<Props> = ({ root }) => {
  const { t } = useTranslation();

  const { tabs } = useTabs();

  return (
    <div className={b()} data-testid="idea-filters">
      <div className={b('list')}>
        {tabs.map((tab) => (
          <NavLink
            key={tab}
            exact={tab === IdeaFilterOption.All}
            className={b('list-item')}
            to={tab === IdeaFilterOption.All ? root : `${root}/${tab.toLowerCase()}`}
            data-testid={`${tab}-filter`}
          >
            {t(tab, { context: 'ideaFilter' })}
          </NavLink>
        ))}
        <NavLink
          data-gtm="stock-etf-list-tab"
          className={b('list-item')}
          to="/investments/stocks"
          data-testid="Stocks-filter"
        >
          {t('Stocks and ETF filter')}
        </NavLink>
      </div>
    </div>
  );
};
